import { type ProgramType } from 'Program';

// All the good stuff is in this directory
export type * from './types';

// This enum is a little unintuitive in that we're effectively combining several columns (status, graduated_with_honors, will_not_graduate_reason_id)
// on the ProgramInclusion model to come up with a single, user-friendly "graduation status."
export enum GraduationStatus {
    failed = 'failed',
    graduated = 'graduated',
    honors = 'honors',
    pending = 'pending',
}

export type SetActivePlaylistParams = {
    program_type: ProgramType;
    playlist_locale_pack_id: string;
};

export type ChangePrefProgramParams = {
    user_program_field_state_id: string;
};

export type EnsureAndChangePrefProgramParams = {
    program_type: ProgramType;
};

export type OfferAdmissionAlumniQuanticLaunchParams = {
    program_type: ProgramType;
};

export type UpdateCurrentUserParams = {
    user: { id: string } & Record<string, unknown>;
};

export type UserActionsResponse = {
    meta: {
        pushMessages: {
            currentUser: Record<string, unknown>;
        };
    };
};

// Legacy alias — existing consumers reference this name
export type SetActivePlaylistResponse = UserActionsResponse;
